import React, { useState } from "react";
// import { Document, Page } from "react-pdf";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/cjs/Page/AnnotationLayer.css";
import "react-pdf/dist/cjs/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfAua = ({ pdfurl }) => {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  // const pdfurl = "https://dev.savart.com/media/AUA/AUA-PMS-proposal%2013.pdf";

  return (
    <>
      <Document file={pdfurl} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={2.5} />
        ))}
      </Document>
    </>
  );
};

export default PdfAua;
